import { useEffect, useState } from 'react'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import { makeStyles } from '@material-ui/core'
import Trovitylogo from 'src/assets/Dashboard/Trovitylogo.svg'
import helpline from 'src/assets/Dashboard/call.svg'
import chat from 'src/assets/Dashboard/chat.svg'
import claims from 'src/assets/Dashboard/hand.svg'
import doc from 'src/assets/Dashboard/documet.svg'
import calendar from 'src/assets/Dashboard/Calender.svg'
import { COLORS } from 'src/utils/Themes/colors'
import Modal from 'src/components/common/Modal'
import MobileVerification from 'src/components/CustomerQRReport/MobileVerification'
import {
  getPolicyInfoFromQr,
  getTokenForQrReport,
} from 'src/services/individualService'
import LoadingModal from 'src/components/common/LoadingModal'
import { getQueryParams } from 'src/utils/commonMethods'
import { useLocation } from 'react-router-dom'
import formatDate from 'src/utils/commonMethods/formatDate'
import { NOTIFICATION_TYPES } from 'src/utils/constants/common'
import { showNotificationMessage } from 'src/actions'
import { useDispatch } from 'react-redux'
import { NOTIFICATION_MSG_REPORTS } from 'src/utils/constants/CustomerReports'

const QRReport = () => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const [policyDetails, setPolicyDetails] = useState()
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [loading, setloading] = useState(false)
  const { search } = useLocation()
  const queryParams = getQueryParams(search)

  const fetchToken = async () => {
    setloading(true)
    const response = await getTokenForQrReport()
    try {
      if (response?.res?.status !== 200) {
        setloading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setloading(false)

      const token = response?.res?.data?.access_token
      // api call to fetch details
      fetchPolicyInfo(token)
    } catch (err) {
      setloading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES.ERROR,
          message: NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_TOKEN_FETCH,
        })
      )
    }
  }

  const fetchPolicyInfo = async (token) => {
    setloading(true)
    const policyNumber = queryParams?.get('id')
    const response = await getPolicyInfoFromQr(token, policyNumber)
    try {
      if (response?.res?.status !== 200) {
        setloading(false)
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES.ERROR,
            message: NOTIFICATION_MSG_REPORTS?.PLEASE_TRY_AGAIN_AFTER_SOMETIME,
          })
        )
      }
      // Success
      setloading(false)
      const policyDetailsResponse = response?.res?.data
      if (policyDetailsResponse?.success) {
        setPolicyDetails(policyDetailsResponse?.policyDetails)
      } else {
        dispatch(
          showNotificationMessage({
            type: NOTIFICATION_TYPES?.ERROR,
            message: policyDetailsResponse?.message,
          })
        )
      }
    } catch (err) {
      setloading(false)
      dispatch(
        showNotificationMessage({
          type: NOTIFICATION_TYPES?.ERROR,
          message:
            NOTIFICATION_MSG_REPORTS?.ENCOUNTERED_ERROR_ON_POLICY_DETAILS,
        })
      )
    }
  }

  useEffect(() => {
    fetchToken()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const getProvider = () => {
    if (policyDetails?.provider?.image) {
      return (
        <>
          <img
            src={policyDetails?.provider?.image}
            className={classes.providerImage}
            alt='Provider'
          />
        </>
      )
    } else if (policyDetails?.provider?.name) {
      return policyDetails?.provider?.name
    } else {
      return '-'
    }
  }

  return (
    <div className={classes.container}>
      <LoadingModal loading={loading} />
      {modalIsOpen && (
        <Modal
          class={classes.modalRoot}
          bgcolor={COLORS?.WHITE}
          width={'80%'}
          left={'10%'}
          top={'10%'}
          ordered={modalIsOpen}
          modelClosed={() => setModalIsOpen(false)}
        >
          <div className={classes.modalContent}>
            <MobileVerification />
          </div>
        </Modal>
      )}

      <div className={classes.trovityLogoContainer}>
        <img src={Trovitylogo} alt='trovity-Logo'></img>
      </div>
      <div className={classes.cardContainer}>
        <Card className={classes.card}>
          <CardContent>
            <div className={classes.contentContainer}>
              <div className={classes.helplineImageContainer}>
                <img src={helpline} alt='helpline'></img>
              </div>
              <div className={classes.contentTextContainer}>
                <div className={classes.headingText}>Insurance Helpline</div>
                <div className={classes.helplineNumber}>1800 3099 247</div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardContent>
            <div className={classes.contentContainer}>
              <div className={classes.chat}>
                <img src={chat} alt='chat'></img>
              </div>
              <div className={classes.contentTextContainerchat}>
                <div className={classes.chatContent}>Chat with Us</div>
              </div>
            </div>
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardContent>
            <div className={classes.contentDocumentcontainer}>
              <div className={classes.contentDocument}>
                <img src={doc} alt='doc'></img>
              </div>
              {policyDetails && (
                <div className={classes.policyDetailsContainer}>
                  <div className={classes.policyDetailsTextContainer}>
                    <span className={classes.policyDetailsText}>
                      Policy No:<b>{policyDetails.policyNumber}</b>
                    </span>
                    <span className={classes.policyDetailsText}>
                      Sum Insured:
                      <b>
                        {policyDetails?.sumAssured
                          ? policyDetails?.sumAssured?.text
                          : '-'}{' '}
                      </b>
                    </span>
                    {policyDetails?.provider && (
                      <span className={classes.policyDetailsText}>
                        <span>Provider:</span>
                        <span>{getProvider()}</span>
                      </span>
                    )}
                  </div>
                  <div className={classes.separatorborder}></div>

                  <div className={classes.dateContainer}>
                    <img src={calendar} alt='calender'></img>

                    <div className={classes.startDateText}>
                      {formatDate(policyDetails?.issuedOn)}
                    </div>
                    <p className={classes.separatorText}> To</p>
                    <div className={classes.expiredDateText}>
                      {formatDate(policyDetails?.expiresOn)}
                    </div>
                  </div>
                  <div className={classes.separatorborder}></div>

                  {/* <div className={classes.buttonContainer}>
                    <Button disabled variant='contained' onClick={() => setModalIsOpen(true)}>
                      View Document
                    </Button>
                  </div> might be future development */}
                </div>
              )}
            </div>
          </CardContent>
        </Card>

        <Card className={classes.card}>
          <CardContent>
            <div className={classes.contentclaimscontainer}>
              <div className={classes.claimsImage}>
                <img src={claims} alt='claims'></img>
              </div>
              <div className={classes.contentclaimscontainertext}>
                <p className={classes.claimsImageText}>Claims</p>

                <div className={classes.claimsText}>
                  <p>Coming soon</p>
                </div>
              </div>
            </div>
          </CardContent>
        </Card>
      </div>
      <p className={classes.copyrightText}>
        © Copyright 2023 trovity.com. All Rights Reserved.
      </p>
    </div>
  )
}

export default QRReport

export const useStyles = makeStyles({
  container: {
    backgroundColor: '#E8E8E8',
    height: '100%',
    width: '100vw',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    minHeight: '100vh',
  },
  cardContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '20px',
    background: '#E8E8E8',
    flexWrap: 'wrap',
    // '@media (min-width:800px)': { flexDirection: 'row' },
  },
  card: {
    padding: '4px',
    background: 'linear-gradient(180deg, #FFFFFF 53.77%, #F5F5F5 100%)',
    boxShadow: '0px 8px 8px rgba(0, 0, 0, 0.2)',
    borderRadius: '10px',
    width: '80%',
    '@media (min-width:800px)': { maxWidth: '300px', minHeight: '80px' },
  },
  headingText: {
    fontSize: '14px',
    lineHeight: '16.41px',
    color: '#000000',
  },
  helplineNumber: {
    fontSize: '22px',
    lineHeight: '25.78px',
    color: '#B92250',
    fontWeight: '500',
  },
  helplineImageContainer: {
    display: 'flex',
    alignContent: 'center',
    justifyContent: 'center',
  },
  chatContent: {
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '46px',
    color: '#000000',
  },
  startDateText: {
    fontWeight: '500',
    fontSize: '13px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#000000',
    padding: '10px',
  },
  expiredDateText: {
    fontWeight: '500',
    fontSize: '13px',
    textAlign: 'center',
    textTransform: 'uppercase',
    color: '#000000',
    padding: '10px',
  },
  chat: {
    left: '20px',
    height: '38px',
  },
  claimsImageText: {
    textAlign: 'center',
  },
  policyDetailsContainer: {
    marginTop: '10px',
  },
  policyDetailsTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  policyDetailsText: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    color: '#000000',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: '5px',
    marginBottom: '5px',
  },
  policyDocumentIdText: {
    fontWeight: '400',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    color: '#000000',
  },
  claimsText: {
    textAlign: 'center',
    fontSize: '17px',
    lineHeight: 'center',
    color: 'rgba(0,0,0,.5)',
  },
  trovityLogoContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '15px',
    paddingTop: '24px',
    paddingBottom: '27px',
  },
  contentContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  contentTextContainer: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
    paddingRight: '10px',
  },
  contentContainerchat: {
    display: 'flex',
    justifyContent: 'space-evenly',
    alignItems: 'center',
    gap: '5px',
  },
  contentTextContainerchat: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '12px',
  },
  contentDocumentcontainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  contentDocumentcontainertext: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  contentclaimscontainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexDirection: 'column',
  },
  claims: {
    fontWeight: '500',
    fontSize: '18px',
    lineHeight: '21px',
    textAlign: 'center',
    color: '#000000',
  },
  modalRoot: {
    padding: '10px',
  },
  modalContent: {
    textAlign: 'center',
    padding: '24px',
    height: 'calc(100% - 48px)',
    overflow: 'auto',
  },
  copyrightText: {
    fontWeight: '400',
    fontSize: '10px',
    lineHeight: '21px',
    textAlign: 'center',
    color: '#000000',
    width: '100%',
  },
  separatorText: {
    fontWeight: '500',
    fontSize: '14px',
    lineHeight: '16px',
    textAlign: 'center',
    color: '#EC1E30',
  },
  dateContainer: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    gap: '5px',
  },
  separatorborder: {
    border: '1px solid #D5D5D5',
  },
  buttonContainer: {
    padding: '15px',
    display: 'flex',
    justifyContent: 'center',
  },
  providerImage: {
    maxHeight: '50px',
    maxWidth: '100px',
  },
})
